import React from "react";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import {
  HasInitValueBox,
  ModalRowContentContainer,
} from "../../../AlimTalk/AlimTalkModal";

interface ReportPartyValidCheckResultModalProps
  extends DefaultModalCommonProps {
  partyId?: number;
  checkResult?: {
    isValid: boolean;
    hasMembership: boolean;
    needCheck: boolean;
    addInfo: string;
  };
}

export default function ReportPartyValidCheckResultModal({
  partyId,
  confirmEvent,
  closeEvent,
  checkResult,
}: ReportPartyValidCheckResultModalProps) {
  return (
    <DefaultModalLayout
      modalTitle={`${partyId ?? 0} 파티 유효성 체크 결과`}
      cancelBtn={<></>}
      confirmEvent={() => {
        if (confirmEvent) confirmEvent();
      }}
      closeEvent={() => closeEvent()}
      isMediumModal={true}
    >
      <ModalRow>
        <ModalLabel>로그인 체크</ModalLabel>

        <ModalRowContentContainer>
          <HasInitValueBox style={{ width: "100%" }}>
            {checkResult?.isValid ? "성공" : "실패"}
          </HasInitValueBox>
        </ModalRowContentContainer>
      </ModalRow>

      <ModalRow>
        <ModalLabel>이용권 체크</ModalLabel>

        <ModalRowContentContainer>
          <HasInitValueBox style={{ width: "100%" }}>
            {checkResult?.hasMembership
              ? "성공"
              : checkResult?.isValid
              ? "실패"
              : "알 수 없음"}
          </HasInitValueBox>
        </ModalRowContentContainer>
      </ModalRow>

      <ModalRow>
        <ModalLabel>2차 인증</ModalLabel>

        <ModalRowContentContainer>
          <HasInitValueBox style={{ width: "100%" }}>
            {!checkResult?.needCheck ? "불필요" : "필요"}
          </HasInitValueBox>
        </ModalRowContentContainer>
      </ModalRow>

      <ModalRow>
        <ModalLabel>추가 정보</ModalLabel>

        <ModalRowContentContainer>
          <HasInitValueBox style={{ width: "100%" }}>
            {!checkResult?.addInfo ? "없음" : checkResult?.addInfo}
          </HasInitValueBox>
        </ModalRowContentContainer>
      </ModalRow>
    </DefaultModalLayout>
  );
}
